import React, { PureComponent } from "react";

import { Button, Row, Col, Container } from "react-bootstrap";

import CajaTexto from "../../../components/UI/cajaTexto/cajaTexto.jsx";
import CajaTextoNumero from "../../../components/UI/cajaTexto/cajaTextoNumero.jsx";
import ComboBox from "../../../components/UI/comboBox/combobox.jsx";
import CheckBox from "../../../components/UI/checkBox/checkBox.jsx";

class MantenimientoItfz extends PureComponent {

  render() {
    const { Datos, listaSucursales, selectedSucursal } = this.props;

    return (
      <Container>
        <Row>
          <Col>
            <CajaTextoNumero
              id="Repartidor_Id"
              type="number"
              label={Datos.Repartidor_Id.attributes.label}
              value={Datos.Repartidor_Id.value}
              attributes={Datos.Repartidor_Id.attributes}
            />
          </Col>
          <Col>
            <CajaTexto
              id="Nombre"
              type="text"
              label={Datos.Nombre.attributes.label}
              value={Datos.Nombre.value}
              attributes={Datos.Nombre.attributes}
              onChangeInput={this.props.onChangeInput}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <ComboBox
              id="Suc_Id"
              label={Datos.Suc_Id.attributes.label}
              attributes={Datos.Suc_Id.attributes}
              value={selectedSucursal}
              datos={listaSucursales}
              onChange={this.props.onhandleSelectedOption}
            />
          </Col>
          <Col className={"mt-5"}>
            <CheckBox
              id="Estatus"
              attributes={Datos.Estatus.attributes}
              value={Datos.Estatus.value}
              label={Datos.Estatus.attributes.label}
              onChange={this.props.handleCheckBox}
            />
          </Col>
        </Row>

        <hr />
        <Row className="mb-3">
          <Col className="text-right">
            <div className="tooltip2">
              <span className="tooltiptext2">Cancelar</span>
              <Button variant="secondary" onClick={this.props.volverAtras}>
                Cancelar
              </Button>
            </div>
            &nbsp;
            <div className="tooltip2">
              <span className="tooltiptext2">Guardar</span>
              <Button variant="primary" onClick={this.props.ingresarDatos}>
                Guardar
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default MantenimientoItfz;
